'use strict'

/* global cf, ga, gtag, sas */

import searchFiltersStorage from "./searchFiltersStorage";

/**
 * @module filters
 * */

import { getUrlParameter, getLang } from '../utils/utils'

const CLASS_LOADER = 'loader'
const CLASS_ACTIV = 'activ'
const CLASS_HIDDEN = 'is-hidden'
const CLASS_EXPANDED = 'is-expanded'
const CLASS_DISABLED = 'disabled'
const CLASS_DESCENDING = 'desc'
const CLASS_SEARCH = 'js-search'
const CLASS_THEMATIC = 'js-thematic'
const CLASS_FAVORITE = 'js-favorite'
const CLASS_RESET_FILTERS = 'lk-reset'
const CLASS_LOAD_MORE = 'load-more'
const CLASS_SORT_BY = 'js-sort-by'
const CLASS_FILTERS_LIST = 'more-filters'

const ID_STATE_SELECT = 'state'
const ID_COUNTY_SELECT = 'county'
const ID_CITY_SELECT = 'city'
const ID_RESULTS = 'js-search-results'
const ID_RESULTS_PROXIMITY = 'js-search-results-proximity'
const ID_MORE = 'js-more'
const ID_MORE_PROXIMITY = 'js-more-proximity'
const ID_VIEW_RESULTS = 'viewres'
const ID_VIEW_RESULTS_PROXIMITY = 'proximity-viewres'
const ID_ASIDE_DISPLAY = 'aside-display'

const ATTRIBUTE_FILTER_LABEL = 'data-filter-label'
const ATTRIBUTE_FILTER_VALUE = 'data-filter-value'
const ATTRIBUTE_FILTER_COUNT = 'data-filter-count'
const ATTRIBUTE_FILTER_INIT = 'data-filter-init'
const ATTRIBUTE_SORT_BY = 'data-sort-by'
const ATTRIBUTE_RESULTS_COUNT = 'data-search-count'
const ATTRIBUTE_CURRENT_PAGE = 'data-pagenum'
const ATTRIBUTE_MAX_PAGE = 'data-max-pagenum'
const ATTRIBUTE_EXCLUDE_TIPS = 'data-exclude-tips'
const ATTRIBUTE_EXCLUDE_SPONSO = 'data-exclude-sponso'
const ATTRIBUTE_THEMATIC_ID = 'data-thematic-id'

const SELECTOR_FILTERS_RECAP_LIST = '.items-filters'
const SELECTOR_FILTERS_RECAP_CONTAINER = '.current-sch'
const SELECTOR_FILTERS_LIST = `.${CLASS_FILTERS_LIST}`
const SELECTOR_FILTER_SELECT_THEMATIC = '.thematic-select'
const SELECTOR_RESULTS = `#${ID_RESULTS}`
const SELECTOR_RESULTS_PROXIMITY = `#${ID_RESULTS_PROXIMITY}`
const SELECTOR_COUNTER_BTN = '.lk-goto'
const SELECTOR_SORT_BY = `.${CLASS_SORT_BY}`
const SELECTOR_ACTIV = `.${CLASS_ACTIV}`

const PARAMETER_QUERY = 'q'
const PARAMETER_PAGE = '/page-'

const API_RESULTS = '/results'
const API_FILTERS = '/more-filters'

const PREFIX_LANG = getLang()
const PREFIX_SEARCH = `${PREFIX_LANG}/api/search`
const PREFIX_SEARCH_FAVORITE = `${PREFIX_SEARCH}/favorite`
const PREFIX_THEMATIC = `${PREFIX_LANG}/api/thematic`

const EMPTY_RESULTS = '<div id="js-search-results" '
                     + 'data-pagenum="1" '
                     + 'data-search-count="0" '
                     + 'data-max-pagenum="0" '
                     + 'data-exclude-tips="" '
                     + 'data-exclude-sponso=""></div>'
const EMPTY_RESULTS_PROXIMITY = '<div id="js-search-results-proximity" '
                      + 'data-pagenum="1" '
                      + 'data-search-count="0" '
                      + 'data-max-pagenum="0" '
                      + 'data-exclude-tips="" '
                      + 'data-exclude-sponso=""></div>'
const EMPTY_FILTERS = '<div class="more-filters"></div>'


const THEMATIC_ID = 'thematic_id[]'
const EXCLUDE_TIPS = 'exclude_tips'
const EXCLUDE_SPONSO = 'exclude_sponso'

const STYLE_BLOCK = 'block'
const STYLE_NONE = 'none'

export default {
  /**
   * @description Initialise filters
   * @returns {undefined}
   */
  init() {
    this.initFilters =
      document.getElementsByClassName(CLASS_SEARCH)[0]
      && document.getElementsByClassName(CLASS_SEARCH)[0].getAttribute(ATTRIBUTE_FILTER_INIT)
    const thematic = document.getElementsByClassName(CLASS_THEMATIC)[0]
    const mainClassList = document.querySelector('main').classList
    let urlFilters = []

    const results = document.getElementById(ID_RESULTS)
    const resultsProximity = document.getElementById(ID_RESULTS_PROXIMITY)
    if (resultsProximity) {
      this.proximityActive = true
      this.currentProximityPage = 1
    }
    this.filters = []
    this.criterias = []
    this.currentSort = ''
    this.currentPage = results.getAttribute(ATTRIBUTE_CURRENT_PAGE)
    this.apiPrefix = `${mainClassList.contains(CLASS_THEMATIC) ? PREFIX_THEMATIC : (
      mainClassList.contains(CLASS_FAVORITE) ? PREFIX_SEARCH_FAVORITE : PREFIX_SEARCH
    )}`
    if (this.initFilters) {
      urlFilters = decodeURIComponent(this.initFilters).replace(/\[\d]/g, '[]').split('&')
      this.filters = this.filters.concat(urlFilters)
    }
    if (thematic) {
      this.criterias.push(`${THEMATIC_ID}=${thematic.getAttribute(ATTRIBUTE_THEMATIC_ID)}`)
    }

    this.bind()
    this.getCriterias()
    this.getTips(results.getAttribute(ATTRIBUTE_EXCLUDE_TIPS))
    this.getSponso(results.getAttribute(ATTRIBUTE_EXCLUDE_SPONSO))

    this.updateSessionStorage('init')

    if (this.filters.length && urlFilters.length < this.filters.length) {
      this.getFilteredResults(false)
    } else {
      this.getFilters()
      if (this.proximityActive) {
        this.getResults(true, false)
      }
    }
  },

  /**
   * @description Bind events on filters elements
   * @returns {undefined}
   */
  bind() {
    if (document.querySelector(SELECTOR_FILTER_SELECT_THEMATIC)) {
      document.querySelector(SELECTOR_FILTER_SELECT_THEMATIC)
          .addEventListener('change', (e) => this.updateFilters(e))
    }
    document.querySelector(SELECTOR_FILTERS_LIST)
            .bindEvent('click', 'li', (e) => this.updateFilters(e))
    document.querySelector(SELECTOR_FILTERS_RECAP_LIST)
            .bindEvent('click', 'li', (e) => this.triggerFromRecap(e))
    document.getElementsByClassName(CLASS_RESET_FILTERS)[0]
            .bindEvent('click', () => this.resetFilters())
    document.getElementsByClassName(CLASS_LOAD_MORE)
            .bindEvent('click', (e) => this.loadMore(e))
    document.getElementsByClassName(CLASS_SORT_BY).bindEvent('click', (e) => this.sortBy(e))
  },

  /**
   * @description Push in criterias object url q parameter value and selects value if set
   * @returns {undefined}
   */
  getCriterias() {
    const query = getUrlParameter(PARAMETER_QUERY)
    const stateSelect = document.getElementById(ID_STATE_SELECT)
    const countySelect = document.getElementById(ID_COUNTY_SELECT)
    const citySelect = document.getElementById(ID_CITY_SELECT)
    const stateValue = stateSelect && stateSelect.value
    const countyValue = countySelect && countySelect.value
    const cityValue = citySelect && citySelect.value

    if (query) {
      this.criterias.push(`${PARAMETER_QUERY}=${query}`)
    }

    if (cityValue && countyValue && stateValue) {
      this.criterias.push(`${ID_STATE_SELECT}=${stateValue}`,
                          `${ID_COUNTY_SELECT}=${countyValue}`,
                          `${ID_CITY_SELECT}=${cityValue}`)
      return
    }

    if (countyValue && stateValue) {
      this.criterias.push(`${ID_STATE_SELECT}=${stateValue}`,
                          `${ID_COUNTY_SELECT}=${countyValue}`)
      return
    }

    if (stateValue) {
      this.criterias.push(`${ID_STATE_SELECT}=${stateValue}`)
    }
  },

  /**
   * @description Update excludeSponso array
   * @param {string} sponso list of sponso
   * @returns {undefined} none
   */
  getSponso(sponso) {
    this.excludeSponso = []
    if (sponso) {
      this.excludeSponso.push(`${EXCLUDE_SPONSO}=${sponso}`)
    }
  },

  /**
   * @description Update excludeTips array
   * @param {string} tips list of tips
   * @returns {undefined} none
   */
  getTips(tips) {
    this.excludeTips = []
    if (tips) {
      this.excludeTips.push(`${EXCLUDE_TIPS}=${tips}`)
    }
  },

  /**
   * @description Update filter object before sending it
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  updateFilters(e) {
    const currentTarget = e.customCurrentTarget ? e.customCurrentTarget : e.target[e.target.selectedIndex]
    const action = !(currentTarget.closest(SELECTOR_FILTERS_RECAP_LIST)
        || currentTarget.classList.contains(CLASS_ACTIV))
    const filterValue = this.getFilterValue(currentTarget)

    if (currentTarget.classList.contains(CLASS_DISABLED)
        && !currentTarget.classList.contains(CLASS_ACTIV)) {
      return
    }

    if (action) {
      if (['facet-loctype[]', 'facet-dest[]'].indexOf(currentTarget.dataset.filterName) !== -1) {
        const key = currentTarget.dataset.filterName.split('-')
        this.filters = this.filters.filter(item => item.indexOf(key[1]) === -1)
        if (filterValue.length > 0) {
            this.filters.push(filterValue)
        }
      } else {
        if (currentTarget.closest('ul').classList.contains('simple-select')) {
          currentTarget.closest('ul').querySelectorAll('li')
              .forEach(elt => elt.classList.remove(CLASS_ACTIV))
        }
        currentTarget.classList.add(CLASS_ACTIV)
        this.filters.push(filterValue)
      }
    } else {
      currentTarget.classList.remove(CLASS_ACTIV)
      this.filters.splice(this.filters.indexOf(filterValue), 1)
    }

    this.updateSessionStorage('update')
    this.resetSort()
    this.getFilteredResults()
  },

  /**
   * @description if filters clicked from SELECTOR_FILTERS_RECAP_LIST, trigger click on filters
   * from SELECTOR_FILTERS_LIST
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  triggerFromRecap(e) {
    const filterFromRecap = e.customCurrentTarget
    const filterFromList = document.querySelector(SELECTOR_FILTERS_LIST).querySelector(
      `[${ATTRIBUTE_FILTER_VALUE}="${filterFromRecap.getAttribute(ATTRIBUTE_FILTER_VALUE)}"]`
    )
    const filterValue = this.getFilterValue(filterFromRecap)

    // Update session storage
    this.removeFilterFromSessionStorage(filterValue)

    e.stopPropagation()

    if (filterFromList) {
      filterFromList.click()
    } else {
      this.filters.splice(this.filters.indexOf(filterValue), 1)
      filterFromRecap.remove()
      this.getFilteredResults()
    }

    if (this.initFilters && window.location.search.indexOf(filterValue)) {
      let search = window.location.search.substr(1).split('&')
      search.splice(search.indexOf(filterValue), 1)
      history.replaceState(
        {}, '', window.location.pathname + search.length ? '?' + search.join('&') : void 0)
    }
  },

  removeFilterFromSessionStorage(filterValue) {
    const removedFilter = filterValue.split('=')
    let key = removedFilter[0].substr(0, removedFilter[0].length - 2)
    if (['classemnt', 'nbtotempl'].indexOf(key) === -1) {
      key = removedFilter[0]
    }
    searchFiltersStorage.removeValue(key, removedFilter[1])
  },

  updateSessionStorage(mode) {
    const region = searchFiltersStorage.getValue('region')
    const dpt = searchFiltersStorage.getValue('dpt')
    if (mode === 'init') {
      searchFiltersStorage.reset()
    }
    const data = {region: region, dpt: dpt}
    this.filters.forEach(item => {
      const parts = item.split('=')
      let key = parts[0]
      if (key === 'state') key = 'region'
      else if (key === 'county') key = 'dpt'
      if (key.indexOf('classemnt') === -1 && key.indexOf('nbtotempl') === -1
          && ['region', 'dpt', 'dpt_i18n', 'region_i18n'].indexOf(key) === -1) {
        if (!data[key]) {
          data[key] = []
        }
        data[key].push(parts[1])
      } else {
        if (['region', 'dpt', 'dpt_i18n', 'region_i18n'].indexOf(key) === -1) {
          key = key.substr(0, parts[0].length - 2)
        }
        data[key] = parts[1]
      }
    })
    if (mode === 'init') {
      const searchParams = new URLSearchParams(location.search)
      searchParams.forEach((value, key) => {
        if (!data[key]) {
          data[key] = []
        }
        if (Array.isArray(data[key])) {
          // Makes sure each value is unique
          if (data[key].indexOf(value) === -1) {
            data[key].push(value)
          }
        } else {
          if (key !== '' || value !== '') {
            data[key] = value
          }
        }
      })
    }
    if (data['dest[]']) {
      if (data['dest[]'].indexOf('lac') !== -1 && data['dest[]'].indexOf('etang') !== -1) {
        data['dest[]'].push('etanglac')
      }
    }
    searchFiltersStorage.set(data)

    this.updateFiltersRecap()
  },

  /**
   * @description add or remove filters from SELECTOR_FILTERS_RECAP_LIST
   * @returns {undefined} none
   */
  updateFiltersRecap() {
    const filtersRecap = document.querySelector(SELECTOR_FILTERS_RECAP_LIST)
    filtersRecap.innerHTML = ''

    Object.entries(searchFiltersStorage.getAll()).forEach(entry => {
      if (entry[0] === 'region' || entry[0] === 'dpt') {
        return
      }
      if (entry[1].length === 0 || entry[1] === '') {
        return
      }

      if (entry[0] === 'classemnt' || entry[0] === 'nbtotempl') {
        let elts = document.querySelectorAll('[data-filter-name="facet-' + entry[0] + '"]')
        elts.forEach(elt => {
          if (elt.classList.contains('activ')) {
            this.addToFiltersRecap(elt.dataset.filterLabel, elt.dataset.filterValue)
          }
        })
      } else if (entry[0] === 'thematic_id[]') {
        entry[1].forEach(thematicId => {
          const elt = document.querySelector(` li[data-filter-value="thematic_id[]=${thematicId}"]`)
          if (!elt) return
          this.addToFiltersRecap(elt.dataset.filterLabel, elt.dataset.filterValue)
        })
      } else if (entry[0] === 'loctype[]') {
        let elts = document.querySelectorAll('[data-filter-name="facet-' + entry[0] + '"]')
        elts.forEach(elt => {
          if (elt.dataset.filterValue) {
            const v = elt.dataset.filterValue.split('=')
            if (entry[1].indexOf(v[1]) !== -1) {
              this.addToFiltersRecap(elt.dataset.filterLabel, elt.dataset.filterValue)
            }
          }
        })
      } else {
        if (entry[0] === 'dest[]' && (entry[1].indexOf('lac') !== -1 && entry[1].indexOf('etang') !== -1)) {
          entry[1].push('etanglac');
        }

        document.querySelectorAll('[name="' + entry[0] + '"]').forEach(elt => {
          if (entry[1].indexOf(elt.defaultValue) !== -1) {
            this.addToFiltersRecap(elt.dataset.filterLabel, elt.dataset.filterValue)
          }
        })
      }
    })
    this.toggleFiltersRecapSideBar()
  },

  /**
   * @description create filter element and append to SELECTOR_FILTERS_RECAP_LIST
   * @param {string} filterString filter name
   * @param {string} filterValue filter value
   * @returns {undefined} none
   */
  addToFiltersRecap(filterString, filterValue) {
    const recapList = document.querySelector(SELECTOR_FILTERS_RECAP_LIST)
    if (recapList.querySelector(`[${ATTRIBUTE_FILTER_VALUE}="${filterValue}"]`)) {
      return
    }
    let itemLi = document.createElement('li')
    itemLi.setAttribute(ATTRIBUTE_FILTER_VALUE, filterValue)
    let itemA = document.createElement('a')
    itemA.innerText = filterString
    itemLi.appendChild(itemA)
    recapList.appendChild(itemLi)
  },

  /**
   * @description show SELECTOR_FILTERS_RECAP_LIST if at least one filter selected, hide if none
   * selected
   * @returns {undefined} none
   */
  toggleFiltersRecapSideBar() {
    const filtersRecap = document.querySelector(SELECTOR_FILTERS_RECAP_LIST)
    const filtersRecapContainer = filtersRecap.closest(SELECTOR_FILTERS_RECAP_CONTAINER)
    if (filtersRecap.childElementCount) {
      filtersRecapContainer.classList.remove(CLASS_HIDDEN)
    } else {
      filtersRecapContainer.classList.add(CLASS_HIDDEN)
    }
  },

  /**
   * @description Reset filters, cookie and sorting, empty SELECTOR_FILTERS_RECAP_LIST and refresh
   * results
   * @returns {undefined} none
   */
  resetFilters() {
    // Update session storage
    document.querySelectorAll(`${SELECTOR_FILTERS_RECAP_LIST} li`).forEach(elt => {
      this.removeFilterFromSessionStorage(elt.dataset.filterValue)
    })

    this.filters = []
    this.resetSort()
    document.querySelector(SELECTOR_FILTERS_RECAP_LIST).innerHTML = ''
    this.toggleFiltersRecapSideBar()
    history.replaceState({}, '', window.location.pathname)
    this.getFilteredResults()
  },

  /**
   * @description increment currentPage and load next results
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  loadMore(e) {
    e.preventDefault()
    const isProximity = e.currentTarget.getAttribute('id') === ID_MORE_PROXIMITY
    if (isProximity) {
      this.currentProximityPage++
    } else {
      this.currentPage++
    }
    this.getResults(isProximity)
  },

  /**
   * @description toggle CLASS_LOAD_MORE link by comparing ATTRIBUTE_MAX_PAGE and currentPage
   * @param {boolean} proximity if for proximity results
   * @returns {undefined} none
   */
  toggleLoadMore(proximity = false) {
    let container = document.getElementById(ID_RESULTS)
    let loadMoreLink = document.getElementById(ID_MORE)
    let loadMore = loadMoreLink.parentNode
    loadMoreLink.href = loadMoreLink.href.replace(/(page-)\d+/, `$1${this.currentPage + 1}`)
    let currentPage = this.currentPage
    if (proximity) {
      container = document.getElementById(ID_RESULTS_PROXIMITY)
      loadMore = document.getElementById(ID_MORE_PROXIMITY).parentNode
      currentPage = this.currentProximityPage
    }
    if (loadMore && currentPage + 1 > Number(container.getAttribute(ATTRIBUTE_MAX_PAGE))) {
      loadMore.classList.add(CLASS_HIDDEN)
    } else {
      loadMore.classList.remove(CLASS_HIDDEN)
    }
  },

  /**
   * @description construct sort parameter, toggle CLASS_ACTIV and CLASS_DESCENDING on
   * sorting link and load sorted results
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  sortBy(e) {
    const current = e.currentTarget
    e.preventDefault()
    let dir = 'asc'
    if (current.classList.contains(CLASS_ACTIV)) {
      if (current.classList.contains(CLASS_DESCENDING)) {
        current.classList.remove(CLASS_DESCENDING)
      } else {
        dir = CLASS_DESCENDING
        current.classList.add(CLASS_DESCENDING)
      }
    }
    this.currentSort = `sort[${current.getAttribute(ATTRIBUTE_SORT_BY)}]=${dir}`
    document.querySelectorAll(`${SELECTOR_SORT_BY}${SELECTOR_ACTIV}`).forEach(element => {
      if (element !== current) {
        element.classList.remove(CLASS_ACTIV, CLASS_DESCENDING)
      }
    })
    current.classList.add(CLASS_ACTIV)
    this.getResults()
  },

  /**
   * @description reset currentSort string and reset sorting links display
   * @returns {undefined} none
   */
  resetSort() {
    const sortBy = document.getElementsByClassName(CLASS_SORT_BY)
    this.currentSort = ''
    if (sortBy.length) {
      sortBy[0].classList.add(CLASS_ACTIV)
      sortBy[0].classList.remove(CLASS_DESCENDING)
      sortBy[1].classList.remove(CLASS_ACTIV, CLASS_DESCENDING)
    }
  },

  /**
   * @description Call API_RESULTS and API_FILTERS with filters object
   * @param {boolean} tagRefresh true if tag should be refreshed
   * @returns {undefined} none
   */
  getFilteredResults(tagRefresh = true) {
    const baseUrl = document.querySelector('div#searchFilters').dataset.baseUrl
    window.location = searchFiltersStorage.generateUrl(baseUrl)
  },

  /**
   * @description Call API_FILTERS with filters object and update html
   * @returns {undefined} none
   */
  getFilters() {
    const options = {
      method: 'get'
    }
    const loaderTarget = document.querySelector(SELECTOR_FILTERS_LIST).querySelector('dl')
    let params = this.filters.slice().concat(this.criterias).concat(this.excludeTips)
    this.toggleLoader(loaderTarget, true)
    fetch(`${this.apiPrefix}${API_FILTERS}?${params.join('&')}`, options).then(response => {
      return response.text()
    }).catch(() => {
      this.toggleLoader(loaderTarget, false)
    }).then(text => {
      this.updateFiltersHTML(text)
      this.updateFiltersRecap()
    })
  },

  /**
   * @description Call API_RESULTS with filters object, sorting and page parameters then
   * update html
   * @param {boolean} proximity if for proximity results
   * @param {boolean} tagRefresh true if tag should be refreshed
   * @returns {undefined} none
   */
  getResults(proximity = false, tagRefresh = true) {
    let idResults = ID_RESULTS
    let currentPage = this.currentPage
    const options = {
      method: 'get'
    }
    let params = this.filters.slice().concat(this.criterias).concat(this.excludeTips).concat(this.excludeSponso)
    let more = false
    if (proximity) {
      idResults = ID_RESULTS_PROXIMITY
      currentPage = this.currentProximityPage
      params.push('proximity=1')
    }
    const loaderTarget = document.getElementById(idResults).parentNode
    if (currentPage > 1) {
      more = true
      params.push(`pagenum=${currentPage}`)
      if (!proximity) {
        history.replaceState(
          {}, '',
          window.location.pathname.split(PARAMETER_PAGE)[0] + PARAMETER_PAGE + currentPage)
      }
    }
    if (this.currentSort) {
      params.push(`${this.currentSort}`)
    }
    this.tagParams = tagRefresh ? params : ''
    this.toggleLoader(loaderTarget, true)
    fetch(`${this.apiPrefix}${API_RESULTS}?${params.join('&')}`, options).then(response => {
      return response.text()
    }).catch(() => {
      this.toggleLoader(loaderTarget, false)
    }).then(text => {
      this.updateResultsHTML(text, more, proximity)
    })
  },

  /**
   * @description return filter's name, set in ATTRIBUTE_FILTER_LABEL attribute
   * @param {object} element filter
   * @returns {string} filter name
   */
  getFilterString(element) {
    return element.getAttribute(ATTRIBUTE_FILTER_LABEL)
  },

  /**
   * @description return filter's value, set in ATTRIBUTE_FILTER_VALUE attribute
   * @param {object} element filter
   * @returns {string} filter value
   */
  getFilterValue(element) {
    return element.getAttribute(ATTRIBUTE_FILTER_VALUE)
  },

  /**
   * @description refresh or append results
   * @param {string} html results html
   * @param {boolean} more true if append results
   * @param {boolean} proximity if for proximity results
   * @returns {undefined}
   */
  updateResultsHTML(html, more = false, proximity = false) {
    if (html === '' || html.indexOf(ID_RESULTS) === -1) {
      html = proximity ? EMPTY_RESULTS_PROXIMITY : EMPTY_RESULTS
    }
    let idResults = ID_RESULTS
    let selectorResults = SELECTOR_RESULTS
    if (proximity) {
      idResults = ID_RESULTS_PROXIMITY
      selectorResults = SELECTOR_RESULTS_PROXIMITY
    }
    const results = document.createElement('div')
    const resultsContainer = document.getElementById(idResults).parentNode
    results.innerHTML = html
    const updatedResults = results.querySelector(selectorResults)
    this.updateResultsNumber(Number(updatedResults.getAttribute(ATTRIBUTE_RESULTS_COUNT)), proximity)
    this.updateCurrentPage(Number(updatedResults.getAttribute(ATTRIBUTE_CURRENT_PAGE)), proximity)
    this.getTips(updatedResults.getAttribute(ATTRIBUTE_EXCLUDE_TIPS))
    this.getSponso(updatedResults.getAttribute(ATTRIBUTE_EXCLUDE_SPONSO))
    this.toggleLoader(resultsContainer, false)
    if (more) {
      resultsContainer.querySelector(selectorResults)
          .insertAdjacentHTML('beforeend', updatedResults.innerHTML)
    } else {
      resultsContainer.innerHTML = results.innerHTML
    }
    this.toggleLoadMore(proximity)

    if (this.tagParams && !proximity) {
      if (window.sas && sas.refresh) {
        sas.refresh(13020, { forceMasterFlag: true })
      }
      // ga('send', 'pageview', `${location.pathname}?${this.tagParams.join('&')}`)
      // gtag('event', 'pageview', `${location.pathname}?${this.tagParams.join('&')}`)
    }
  },

  /**
   * @description add class CLASS_DISABLED on filters with ATTRIBUTE_FILTER_COUNT set to 0
   * add class CLASS_ACTIV on filters present in filters object
   * update filters html
   * @param {string} html filters html
   * @returns {undefined}
   */
  updateFiltersHTML(html) {
    if (html === '' || html.indexOf(CLASS_FILTERS_LIST) === -1) {
      html = EMPTY_FILTERS
    }
    const filters = document.createElement('div')
    filters.innerHTML = html
    filters.querySelectorAll(`[${ATTRIBUTE_FILTER_COUNT}="0"]`).forEach(element => {
      element.classList.add(CLASS_DISABLED)
    })
    const filters_select = document.getElementsByClassName('thematic-select')
    Object.entries(searchFiltersStorage.getAll()).map(entry => {
      if (entry[0].indexOf('[]') === - 1) {
        entry[0] += '[]'
      }
      if (Array.isArray(entry[1])) {
        entry[1].forEach(value => {
          if (filters_select.length !== 0 && (entry[0] === 'dest[]' || entry[0] === 'loctype[]')) {
            this.updateFilter(entry[0], value, filters_select[0])
          }
          this.updateFilter(entry[0], value, filters)
        })
      } else {
        this.updateFilter(entry[0], entry[1], filters)
      }
    })
    this.toggleLoader(document.querySelector(SELECTOR_FILTERS_LIST).querySelector('dl'), false)
    document.querySelector(SELECTOR_FILTERS_LIST).innerHTML =
      filters.querySelector(SELECTOR_FILTERS_LIST).innerHTML
  },

  updateFilter(key, value, filters) {
    const filter = [key, value].join('=')
    const filterFromList = filters.querySelector(`[${ATTRIBUTE_FILTER_VALUE}="${filter}"]`)
    if (filterFromList) {
      if (key === 'dest[]' || key === 'loctype[]') {
        filterFromList.setAttribute('selected', 'true')
      } else {
        const filterContainer = filterFromList.closest('dd')
        filterFromList.classList.add(CLASS_ACTIV)
        filterContainer.classList.add(CLASS_ACTIV)
        filterContainer.previousSibling.classList.add(CLASS_ACTIV)
      }
      this.updateFiltersRecap(this.getFilterString(filterFromList),
          this.getFilterValue(filterFromList), true)
    }
  },

  /**
   * @description update number of results from the API_RESULTS response
   * @param {number} count number of results
   * @param {boolean} proximity if for proximity results
   * @returns {undefined}
   */
  updateResultsNumber(count, proximity = false) {
    if (proximity) {
      document.getElementById(ID_VIEW_RESULTS_PROXIMITY).querySelector('h2').innerHTML =
        count === 1 || count === 0
          ? cf.results.singleproximitytxt.replace('%s', count)
          : cf.results.pluralproximitytxt.replace('%s', count)
      if (count === 0) {
        document.getElementById(ID_VIEW_RESULTS_PROXIMITY).classList.add(CLASS_HIDDEN)
      }
    } else {
      const counterBtn = document.querySelector(SELECTOR_COUNTER_BTN)
      if (counterBtn) {
        if (!count) {
          counterBtn.classList.add(CLASS_HIDDEN)
        } else {
          counterBtn.classList.remove(CLASS_HIDDEN)
          counterBtn.querySelector('.txt').innerHTML =
            count === 1 ? cf.results.singlebtn : cf.results.pluralbtn.replace('%s', count)
        }
      }
      document.getElementById(ID_VIEW_RESULTS).querySelector('.title-sch').innerHTML =
        count === 1 || count === 0 ?
        cf.results.singletxt.replace('%s', count) : cf.results.pluraltxt.replace('%s', count)
    }
  },

  /**
   * @description update currentPage or currentProximityPage
   * @param {number} number ATTRIBUTE_CURRENT_PAGE from api response
   * @param {boolean} proximity if for proximity results
   * @returns {undefined}
   */
  updateCurrentPage(number, proximity = false) {
    if (proximity) {
      this.currentProximityPage = number
    } else {
      this.currentPage = number
    }
  },

  /**
   * @description show or hide loader
   * @param {Element} target element which will display the loader
   * @param {boolean} state show or hide
   * @returns {undefined}
   */
  toggleLoader(target, state) {
    if (!target) {
      return
    }
    if (state) {
      target.classList.add(CLASS_LOADER)
    } else {
      target.classList.remove(CLASS_LOADER)
    }
  },


  /**
   * @description display or hide callback bind on events
   * @param {event} e
   * @returns {undefined} none
   * How to use in DOM:
   * - on fire event element id="myIdFired-display"
   * - on display content element  id=myIdFired  and class="is-hidden"
  */
    toggleDisplayBlock(e) {
    const id = e.currentTarget.id.split('-')[0]
    const toDisplayBlock = document.getElementById(id);
    const expanded = toDisplayBlock.classList.contains(CLASS_EXPANDED)
    if (expanded) {
      toDisplayBlock.classList.remove(CLASS_EXPANDED)
    } else {
      toDisplayBlock.classList.add(CLASS_EXPANDED)
    }
  },

}




// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/filters.js